import PageContainer from '../components/common/PageContainer';
import Layout from '../components/common/Layout';
import FacilityScreen from '../components/screens/facilities2/FacilityScreen';

export default function Facility(props) {
  return (
    <Layout headerTitle="facilities">
      <PageContainer id="facilities">
        <FacilityScreen props={props} />
      </PageContainer>
    </Layout>
  );
}
